import { useState } from "react";
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { useFormikContext } from "formik";
import { ICampaignFormState, IFormFieldRecord } from "../../App/Typings/Campaigns";
import Modal from "../../App/Components/Modal/Modal";

interface ArchivedFieldsModalProps {
  fields: IFormFieldRecord;
}

export default function ArchivedFieldsModal({ fields }: ArchivedFieldsModalProps) {
  const [open, setIsOpen] = useState<boolean>(false);
  const { setFieldValue, values } = useFormikContext<ICampaignFormState>();
  const handleClose = () => setIsOpen(false);

  const unarchiveClick = (id: string) => {
    const updateField = { ...values?.formFields[id] };
    updateField.archived = false;

    setFieldValue(`formFields.${id}`, updateField);
  };

  return (
    <>
      <Button data-test="open-archived-fields-modal" variant="outlined" onClick={() => setIsOpen(true)}>
        View Archived Fields
      </Button>
      <Modal
        title="Archived Fields"
        isOpen={open}
        handleCloseModal={handleClose}
        dataTestId="archived-fields"
        content={
          <>
            {fields && Object.keys(fields).length > 0 ? (
              <TableContainer>
                <Table aria-label="simple table">
                  <TableBody>
                    {Object.keys(fields).map((k, v) => (
                      <TableRow
                        key={fields[k].fieldName}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {fields[k].label}
                        </TableCell>
                        <TableCell>{fields[k].fieldName}</TableCell>
                        <TableCell align="right">
                          <IconButton
                            data-test="archive-field-button"
                            aria-label={`restore field`}
                            title={"Restore field"}
                            sx={{ border: "1px solid", borderRadius: ".2em", marginLeft: "1em" }}
                            color="primary"
                            size="small"
                            onClick={() => unarchiveClick(k)}
                          >
                            <UnarchiveIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p>No archived fields.</p>
            )}
          </>
        }
        footerContent={<></>}
      />
    </>
  );
}
